/**
 * NUTRIHANGAR RECENTLY VIEWED (LocalStorage Based)
 * v4 - Native Theme Refresh & Robust Image Logic
 */
(function () {
    const KEY = 'nh_recently_viewed_v2';
    const MAX_ITEMS = 6;

    // 1. SAVE
    const saveCurrentProduct = () => {
        if (!window.nhCurrentProduct) return;
        let history = JSON.parse(localStorage.getItem(KEY) || '[]');
        const current = window.nhCurrentProduct;

        // Rimuovi duplicati basati su handle
        history = history.filter(item => item.handle !== current.handle);

        // Aggiungi in cima
        history.unshift(current);

        // Limita lunghezza
        if (history.length > MAX_ITEMS) history = history.slice(0, MAX_ITEMS);
        localStorage.setItem(KEY, JSON.stringify(history));
    };

    // 2. THEME REFRESH LOGIC (Critical for Krown Themes)
    const nhRefreshThemeCart = async () => {
        try {
            // Fetch della sezione helper del carrello
            const res = await fetch('?section_id=helper-cart');
            const text = await res.text();

            // Parsing
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            const newForm = doc.getElementById('AjaxCartForm');
            const newSubtotal = doc.getElementById('AjaxCartSubtotal');

            // Update DOM
            const currentForm = document.getElementById('AjaxCartForm');
            const currentSubtotal = document.getElementById('AjaxCartSubtotal');

            if (newForm && currentForm) currentForm.innerHTML = newForm.innerHTML;
            if (newSubtotal && currentSubtotal) currentSubtotal.innerHTML = newSubtotal.innerHTML;

            // RE-INIT THEME LISTENERS
            // Krown theme usa un Custom Element <cart-form>
            const cartFormEl = document.querySelector('cart-form');
            if (cartFormEl && typeof cartFormEl.ajaxifyCartItems === 'function') {
                cartFormEl.ajaxifyCartItems();
            }

            // Update Header Counts & Totals
            const count = newForm.querySelector('[data-cart-count]') ? newForm.querySelector('[data-cart-count]').textContent : null;
            const total = newForm.querySelector('[data-cart-total]') ? newForm.querySelector('[data-cart-total]').textContent : null;

            if (count) {
                document.querySelectorAll('[data-header-cart-count]').forEach(el => el.textContent = count);
                document.querySelectorAll('.mbn-cart-count').forEach(el => el.textContent = count);
            }
            if (total) {
                document.querySelectorAll('[data-header-cart-total]').forEach(el => el.textContent = total);
            }

            // NutriHangar Custom Visuals (Barra, Haptics)
            if (window.updateCartVisuals) window.updateCartVisuals();

            return true;
        } catch (e) {
            console.error('NH Refresh Cart Error:', e);
            return false;
        }
    };

    // 3. QUICK ADD
    window.nhQuickAddRecent = async (variantId, btn) => {
        if (!variantId) return;

        // UI Loading
        const originalContent = btn.innerHTML;
        btn.innerHTML = '<span style="display:inline-block; animation:spin 1s linear infinite">⟳</span>';
        btn.style.pointerEvents = 'none'; // Previene doppi click

        try {
            // Quantità minima: priorità al dato pre-calcolato dal server (include metafield)
            let minQty = 1;
            const stored = JSON.parse(localStorage.getItem(KEY) || '[]');
            const product = stored.find(p => p.variant_id === variantId);
            if (product) {
                if (product.min_qty && product.min_qty > 1) {
                    minQty = product.min_qty;
                } else if (!product.min_qty && product.price > 0 && product.price < 800) {
                    // Fallback per prodotti salvati prima dell'aggiornamento (senza min_qty)
                    minQty = Math.floor(800 / product.price) + 1;
                }
            }

            const addRes = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: minQty }] })
            });
            const addedItem = await addRes.json();

            // Feedback Successo
            btn.innerHTML = '✔';
            btn.style.background = '#28a745';
            btn.style.color = '#fff';
            if (window.nhHaptics) window.nhHaptics('success');

            // Rimuovi dal localStorage per evitare che riappaia
            let remaining = JSON.parse(localStorage.getItem(KEY) || '[]');
            remaining = remaining.filter(p => p.variant_id !== variantId);
            localStorage.setItem(KEY, JSON.stringify(remaining));

            // REFRESH TOTALE DEL CARRELLO
            await nhRefreshThemeCart();

            // RE-RENDER RECENTLY VIEWED (rimuove visivamente il prodotto aggiunto)
            setTimeout(() => {
                renderRecentlyViewed();
            }, 300);

        } catch (e) {
            console.error(e);
            btn.innerHTML = '!';
            btn.style.background = '#d32f2f';

            setTimeout(() => {
                btn.innerHTML = originalContent;
                btn.style.background = '';
                btn.style.color = '';
                btn.style.pointerEvents = 'auto';
            }, 2000);
        }
    };

    // 4. RENDER
    const renderRecentlyViewed = async () => {
        const container = document.getElementById('nh-recent-products-list');
        const wrapper = document.getElementById('nh-recent-products-wrapper');
        if (!container || !wrapper) return;

        let history = JSON.parse(localStorage.getItem(KEY) || '[]');

        if (history.length === 0) {
            wrapper.style.display = 'none';
            return;
        }

        // --- FILTER: ESCLUDI PRODOTTI ESAURITI (check real-time via API) ---
        const availableHistory = [];
        for (const p of history) {
            // Se il dato localStorage ha il campo available=false, salta direttamente
            if (p.available === false) continue;
            try {
                const prodRes = await fetch(`/products/${p.handle}.js`, { cache: 'no-store' });
                if (prodRes.ok) {
                    const prodData = await prodRes.json();
                    if (prodData.available) {
                        availableHistory.push(p);
                    }
                }
            } catch (e) {
                // In caso di errore di rete, includi il prodotto per sicurezza
                availableHistory.push(p);
            }
        }
        history = availableHistory;

        // --- FILTER: EXCLUDE ITEMS IN CART ---
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            const cartProductIds = new Set(cart.items.map(item => item.product_id));

            // Filtra via i prodotti già nel carrello
            history = history.filter(p => !cartProductIds.has(p.id));
        } catch (e) {
            console.warn('NH Recent: Cart filter skipped', e);
        }

        if (history.length === 0) {
            wrapper.style.display = 'none';
            return;
        }

        const formatMoney = (cents) => '€' + (cents / 100).toFixed(2).replace('.', ',');
        let html = '';

        history.forEach(p => {
            // Price Logic
            let priceHtml = `<span class="nh-recent-price">${formatMoney(p.price)}</span>`;
            if (p.compare_at_price && p.compare_at_price > p.price) {
                priceHtml = `
                    <div style="display:flex; flex-direction:column; line-height:1.1; align-items:flex-start;">
                        <span style="display:inline-flex; align-items:baseline; gap:4px; margin-bottom:3px; padding:2px 6px; border:1px solid #cfc4a8; border-radius:4px; background:#fff; line-height:1.2; white-space:nowrap; font-size:10px; color:#6a6a6a;">Listino <del style="font-size:10px; color:#6a6a6a; font-weight:400;">${formatMoney(p.compare_at_price)}</del></span>
                        <span class="nh-recent-price">${formatMoney(p.price)}</span>
                    </div>
                `;
            }

            // Image Fallback (Robust URL Validation)
            let imgSrc = 'https://cdn.shopify.com/s/images/themes/product-1.png';
            if (p.image && typeof p.image === 'string' && p.image.length > 10) {
                imgSrc = p.image.startsWith('//') ? ('https:' + p.image) : p.image;
            }

            html += `
            <div class="nh-recent-item">
                <a href="${p.url}" class="nh-recent-img-link">
                    <img src="${imgSrc}" alt="${p.title}" loading="lazy">
                </a>
                <div class="nh-recent-info">
                    <a href="${p.url}" class="nh-recent-title" title="${p.title}">${p.title}</a>
                    <div class="nh-recent-price-row">
                        ${priceHtml}
                        <button class="nh-recent-add-btn" aria-label="Aggiungi al carrello" onclick="window.nhQuickAddRecent(${p.variant_id}, this)">
                            +
                        </button>
                    </div>
                </div>
            </div>
            `;
        });

        container.innerHTML = html;
        wrapper.style.display = 'block';

        // Re-start Scroll only if needed
        startAutoScroll(container);
    };

    let scrollInterval;
    const startAutoScroll = (el) => {
        if (scrollInterval) clearInterval(scrollInterval);

        scrollInterval = setInterval(() => {
            if (!el || !document.body.contains(el)) {
                clearInterval(scrollInterval); return;
            }
            if (el.matches(':hover')) return; // Pausa se hover

            const step = el.clientWidth;

            if (el.scrollLeft + step >= el.scrollWidth - 10) {
                el.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                el.scrollBy({ left: step, behavior: 'smooth' });
            }
        }, 4000);
    };

    // INIT
    document.addEventListener('DOMContentLoaded', () => {
        saveCurrentProduct();
        renderRecentlyViewed();
        window.nhRenderRecent = renderRecentlyViewed;
    });

})();
